import React, { ReactElement, useState } from "react";
import { Application } from "./Application";

import { Alert, Col, Image, Row } from "react-bootstrap";
import StepZilla from "react-stepzilla";
import { Lead } from "../leads";
import {
	StepDeclaration,
	StepGovernmentId,
	StepOne,
	StepPaymentOptions,
	StepSubmitted,
	StepThreeIndividual,
} from "./ced";

import { Payment } from "../payments";

export const ModuleApplication = (): ReactElement => {
	const [application] = useState(
		new Application({
			applyingFor: "Module",
			applyingAs: "An Individual",
			lead: new Lead(),
		}),
	);

	const [payment] = useState(new Payment({ application }));

	const [, setStep] = useState(0);

	document.title = "Short Courses (Module) Application";

	let steps;

	steps = [
		{
			name: "",
			component: <StepOne application={application} nextStep={1} />,
		},
		{
			name: "",
			component: (
				<StepThreeIndividual application={application} nextStep={2} />
			),
		},
		{
			name: "",
			component: (
				<StepGovernmentId application={application} nextStep={3} />
			),
		},
		{
			name: "",
			component: (
				<StepPaymentOptions
					application={application}
					nextStep={4}
					payment={payment}
				/>
			),
		},
		{
			name: "",
			component: (
				<StepDeclaration application={application} nextStep={5} />
			),
		},
		{
			name: "",
			component: <StepSubmitted application={application} />,
		},
	];

	return (
		<div className="container" id="ced-application">
			<div className="stepzilla-well">
				<Row className="text-center">
					<Col
						xs={{ span: 12, offset: 0 }}
						sm={{ span: 6, offset: 3 }}
					>
						<Image
							src="/images/module_logo.jpg"
							className="mb-3"
							style={{ maxWidth: "100%", height: "auto" }}
						/>
					</Col>
				</Row>
				{application.applicationId ? (
					<Alert variant="info">
						Your application ID is:{" "}
						<strong>{application.applicationId}</strong>. Please
						save your application ID for your reference.
					</Alert>
				) : null}

				<StepZilla
					stepsNavigation={false}
					showNavigation={false}
					onStepChange={(step: any) => setStep(step)}
					steps={steps}
				/>
			</div>
		</div>
	);
};
